import styled from "styled-components";
import { SecondaryButtonAtom } from "./Generic/SecondaryButton";
import { useSettingsStorageContext } from "../ContextLayer/SettingsStorageProvider";
// import { useMediaQuery } from "@mui/material";

const AddButtonAtom = styled(SecondaryButtonAtom)<{$interactive?: boolean, $opaque?: boolean, $darkMode: boolean}>`
    position: relative;
    width: 30px;
    height: 30px;
    background: ${props => props.$opaque ? "#D9D5D3" : "rgba(255, 255, 255, 0.2)"};
    opacity: 1;
    z-index: 10;

    transition: opacity var(--transition-duration-normal);

    & path {
        fill: ${props => props.$darkMode ? '#FEF7E2' : '#3B3B3B'};
        transition: fill var(--transition-duration-normal);
    }

    &:hover {
        background-color: ${props => props.$opaque ? "#D9D5D3" : "gba(255, 255, 255, 0.3)"};
    }
        
    @media screen and (orientation: landscape) and (min-width: 1200px) {
        opacity: 0;
        pointer-events: none;
    }
`

export interface AddButtonProps {
    onClick?: () => void,
    opaque: boolean
}

export default function AddButton(props: AddButtonProps) {
    const { settings } = useSettingsStorageContext();
    // const interactive = useMediaQuery('screen and (orientation: landscape) and (max-width: 1200px)');

    return (
        <AddButtonAtom onClick={props.onClick} $opaque={props.opaque} $darkMode={settings.darkMode}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M7.54605 17C7.54605 17.7456 8.15046 18.35 8.89605 18.35C9.64163 18.35 10.246 17.7456 10.246 17V10.85H16.3955C17.1411 10.85 17.7455 10.2456 17.7455 9.5C17.7455 8.75442 17.1411 8.15 16.3955 8.15H10.246V2.00002C10.246 1.25444 9.64163 0.650023 8.89605 0.650023C8.15046 0.650023 7.54605 1.25444 7.54605 2.00002V8.15H1.39551C0.649923 8.15 0.0455078 8.75442 0.0455078 9.5C0.0455078 10.2456 0.649923 10.85 1.39551 10.85H7.54605V17Z" fill="#3B3B3B"/>
            </svg>
        </AddButtonAtom>
    )
}